<template>
  <ItemSelectModal
    title="コース選択"
    :items="courses"
    :minItemSize="64"
    :unselectableItemIds="selectedCourseIds"
    :loading="busy"
    v-on="selectListeners"
  >
    <template v-slot="{ item }">
      <div class="course">
        <div class="course-info">
          <p class="name">{{ item.names.jpn || 'コースなし' }}</p>
          <p v-if="item.price" class="price">¥{{ numberFormat(item.price) }}</p>
        </div>
        <div class="check"><CheckIcon v-if="isSelected(item)" class="check-icon" /></div>
      </div>
    </template>
  </ItemSelectModal>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { numberFormat } from '@/utils/number'
import CheckIcon from '@/components/icons/CheckIcon'
import ItemSelectModal from '@/components/molecules/ItemSelectModal'

export default {
  name: 'CourseSelectModal',
  components: {
    CheckIcon,
    ItemSelectModal,
  },
  props: {
    index: Number,
  },
  computed: {
    ...mapState({
      busy: state => state.courses.busy,
      reservation: state => state.reserves.edit.reservation,
    }),
    ...mapGetters({
      allCourses: 'courses/all',
    }),
    courses() {
      return [{ id: null, names: { jpn: null }, price: null }].concat(this.allCourses)
    },
    selectListeners() {
      return { ...this.$listeners, select: this.select }
    },
    selectedCourseIds() {
      return this.reservation.courses
        .map(c => c.id)
        .filter(v => v !== null && v !== undefined && v !== this.reservation.courses[this.index].id)
    },
  },
  mounted() {
    this.$store.dispatch('courses/get')
  },
  methods: {
    numberFormat,
    select(course) {
      this.$emit('select', this.index, course)
    },
    isSelected(item) {
      if (!this.reservation.courses.length || isEmpty(this.reservation.courses[this.index])) return item.id === null
      return item.id === this.reservation.courses[this.index].id
    },
  },
}
</script>

<style lang="postcss" scoped>
.course {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.course-info {
  display: grid;
  grid-gap: 8px;
  width: 280px;
}

.name {
  font-weight: 600;
}

.price {
  font-size: 12px;
}

.check-icon {
  >>> path {
    fill: var(--brand-color);
  }
}
</style>
